<div class="row margin-bottom-20">
	<div fxFlex fxLayoutGap="5px">
		<button id="edit-pay" mat-raised-button color="primary" (click)="navigate('0')">
			Create New Aircraft Model
		</button>
	</div>
	<div fxFlex></div>
	<mat-checkbox
		name="onlyArchived"
		id="ARCHIVED_AIRCRAFT_MODELS_TOGGLE"
		[(ngModel)]="onlyArchived"
		(ngModelChange)="changeFilter()"
	>
		<small>Archived</small>
	</mat-checkbox>
</div>
<h3 class="readonly-label">
	Aircraft Models
</h3>
<div fxLayout="row wrap">
	<div
		fxFlex.sm="100%"
		fxFlex.xs="100"
		fxFlex.md="33.33%"
		fxFlex.lg="33.33%"
		fxFlex.xl="33.33%"
		fxFlex="100%"
		*ngFor="let model of aircraftModels"
	>
		<app-aircraft-models-card [aircraftModel]="model" [isArchived]="this.onlyArchived"> </app-aircraft-models-card>
	</div>
</div>
